import React from 'react'
import { FBPage } from 'components/FbUI/Page/FBPage'
import {
  FBPageHeader,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { ProductTable } from 'components/Tables/ProductTable'

export const ProductsPage: React.FC = () => {
  return (
    <FBPage>
      <FBPageHeader>
        <FBPageTitleRow>
          <FBPageTitle>Products</FBPageTitle>
        </FBPageTitleRow>
      </FBPageHeader>

      <FBPageTableContainer>
        <ProductTable tableKey="products-page-table" />
      </FBPageTableContainer>
    </FBPage>
  )
}
